import { render, staticRenderFns } from "./ClientCMSRoot.vue?vue&type=template&id=33dc5f68&scoped=true&"
import script from "./ClientCMSRoot.vue?vue&type=script&lang=js&"
export * from "./ClientCMSRoot.vue?vue&type=script&lang=js&"
import style0 from "./ClientCMSRoot.vue?vue&type=style&index=0&id=33dc5f68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dc5f68",
  null
  
)

export default component.exports